module.exports = __webpack_public_path__ + "img/2.663732d9.png";